<template>
  <div class="flex flex-wrap p-2" style="width: calc(100% - 75px)">
    <div
      @click.stop.prevent="open = !open"
      class="text-xs bg-g2 hover:bg-flyingeye-light h-full flex items-center justify-center !h-fit cursor-pointer px-[8px] py-[2px] mr-2 mb-1"
      :class="{ '!bg-flyingeye': open }"
    >
      {{ $e("Vidéo") }}
    </div>
  </div>

  <div
    class="relative w-full bg-black"
    v-if="open != false"
    :class="$root.isPopup ? 'h-full' : 'aspect-video'"
  >
    <div
      class="absolute flex justify-end top-[2px] z-50 w-full px-[6px] px-0 left-0 h-[14px]"
    >
      <!-- QrCode -->
      <div
        class="ml-3 cursor-pointer hover:text-flyingeye-light transition-all"
        v-if="!$root.isPopup"
        @click="
          config.qrCodeOpen = config.qrCodeOpen == false ? getFlux() : false
        "
        :class="{ 'text-flyingeye-light': config.qrCodeOpen != false }"
      >
        <SVG name="qrcode" css="h-full fill-current"></SVG>
      </div>

      <!-- Popup -->
      <div
        @click.stop.prevent="openPopup()"
        class="ml-3 cursor-pointer hover:text-flyingeye-light transition-all"
      >
        <svg
          class="fill-current h-full"
          v-if="!$root.isPopup"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 18"
        >
          <path
            d="M15.75,18h-4.5V15.75h4.5v-4.5H18V18ZM2.25,18H0V11.25H2.25v4.5h4.5V18ZM15.75,6.75V2.25h-4.5V0H18V6.75ZM0,6.75V0H6.75V2.25H2.25v4.5Z"
          />
        </svg>
        <svg
          class="fill-current h-full"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 18"
          v-else
        >
          <path
            d="M11.25,18V11.25H18V13.5H13.5V18ZM4.5,18V13.5H0V11.25H6.75V18Zm9-11.25H11.25V0H13.5V4.5H18V6.75Zm-9,0H0V4.5H4.5V0H6.75V6.75Z"
          />
        </svg>
      </div>

      <!-- Close -->
      <div @click.stop.prevent="close()" class="ml-3">
        <svg
          viewBox="0 0 89 95"
          fill="none"
          class="fill-current h-full fill-current hover:fill-flyingeye-light transition-all"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.4 44.6C46.3 44.6 47.8 43.1 47.8 41.2V3.4C47.8 1.5 46.3 0 44.4 0C42.5 0 41 1.5 41 3.4V41.2C41 43.1 42.5 44.6 44.4 44.6Z"
          />
          <path
            d="M63.6 10.7C61.9 9.89999 59.9 10.6 59 12.3C58.2 14 58.9 16 60.6 16.9C73.5 23.1 81.8 36.3 81.8 50.7C81.8 71.4 65 88.2 44.3 88.2C23.6 88.2 6.9 71.3 6.9 50.7C6.9 36.4 15.2 23.1 28.1 16.9C29.8 16.1 30.5 14 29.7 12.3C28.9 10.6 26.8 9.89999 25.1 10.7C9.9 18 0 33.7 0 50.6C0 75.1 19.9 94.9 44.3 94.9C68.7 94.9 88.6 75 88.6 50.6C88.7 33.7 78.9 18.1 63.6 10.7Z"
          />
        </svg>
      </div>
    </div>
    <div class="absolute w-full h-full" style="padding: 18px 5px 5px">
      <iframe
        :id="`video_container_${config.deviceFamilly.this_dev_sn}`"
        class="w-full h-full"
        :src="getFlux()"
        frameborder="0"
      ></iframe>
    </div>
  </div>

  <!-- <Video_QrCode v-if="config?.qrCodeOpen != false" :config="config" /> -->
</template>
<script>
import { ref } from "vue";
import SVG from "@/partials/SVG.vue";
import Video_QrCode from "@/partials/Video/Video_QrCode.vue";

export default {
  name: "Videos_Externe",
  components: {
    SVG,
    Video_QrCode,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      open: ref(false),
      state_info: ref({
        base: "",
        videoOff: $root.$e("Extinction du flux vidéo"),
        videoOn: $root.$e("Mise en route du flux vidéo"),
        lastConfig: $root.$e("Allumage..."),
        reload_webrtc: $root.$e("Erreur du flux vidéo"),
        error_webrtc: $root.$e("Recherche du flux vidéo"),
      }),
    };
  },

  async mounted() {
    if (this.autoload != false) {
      this.config.videos.forEach((video) => {
        if (video.dvv_id == this.autoload) {
          this.open = true;
        }
      });
    }
  },

  beforeUnmount() {
    this.close();
  },

  methods: {
    async close() {
      this.open = false;
    },

    openPopup() {
      // open in new tab
      window.open(this.getFlux(), "_blank");
    },

    getFlux() {
      return (
        window.location.origin +
        "/flux/webrtc/" +
        this.config.deviceFamilly.this_dev_sn +
        "/live1"
      );
    },
  },
};
</script>
